import React, { useState } from 'react';
import FormHeader from '../../../components/shared/form/formHeader';
import ListagemBiblioteca from '../../../components/documento/consultar';
import Button from '@material-ui/core/Button';

const ConsultarBiblioteca = () => {

  
  const [modalOpen, setModalOpen] = useState(false);
  const ActionButton = () => <Button variant="contained" onClick={() => setModalOpen(true)}>Novo documento</Button>;

  return (
    <>
        <div>
          <FormHeader ActionButton={ActionButton} titulo="Biblioteca" />
          <ListagemBiblioteca modalOpen={modalOpen} setModalOpen={setModalOpen}/>
        </div>
    </>
  )
};

export default ConsultarBiblioteca;
